export const StarIcon = () => (
  <svg
    width="12"
    height="11"
    viewBox="0 0 12 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.32653 0.375475C5.49688 0.0330446 5.98516 0.0330446 6.15551 0.375475L7.54472 3.17177C7.61213 3.30732 7.74149 3.40142 7.89089 3.42356L10.98 3.88086C11.358 3.93689 11.5092 4.40138 11.2359 4.66893L9.00591 6.85442C8.8975 6.96037 8.84831 7.1125 8.87381 7.26181L9.39306 10.3407C9.45683 10.7177 9.06147 11.0048 8.72259 10.8278L5.95509 9.38216C5.82118 9.31211 5.66085 9.31211 5.52694 9.38216L2.75943 10.8278C2.42028 11.0048 2.0252 10.7177 2.08869 10.3407L2.60821 7.26181C2.63363 7.1125 2.58426 6.96037 2.47595 6.85442L0.245634 4.66893C-0.0270169 4.40138 0.123835 3.93689 0.501794 3.88086L3.59115 3.42356C3.74054 3.40142 3.8699 3.30732 3.93731 3.17177L5.32653 0.375475Z"
      fill="#424242"
    />
  </svg>
);
